import api from 'ApiConfig';

const classServices = {
  getBatchDetails: async () => {
    return api.get('/student/get-batch-details');
  },
};
export default classServices;
